import { Unreachable } from '@lemon8/web-app-shared/util';
import { atom } from 'jotai';
import { PromiseOrValue } from 'shared/utils/promise-or-value';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';
import { TArticleDetail } from 'shared/models/article';

export interface IUserPosts {
  items: TArticleDetail[];
  hasMore: boolean;
  maxBeHotTime: string;
}

type TUserPostStore = { [key: string]: PromiseOrValue<IUserPosts> | undefined };

export const $UserPostStore = atom({} as TUserPostStore);

export const $UserPost = safeAtomFamily((userLinkName: string) => {
  const a = atom<PromiseOrValue<IUserPosts>, [PromiseOrValue<IUserPosts>], void>(
    (get) => {
      const data = get($UserPostStore)[userLinkName];
      if (!data) {
        return Unreachable('no data in $UserPost');
      }
      return data;
    },
    (get, set, input: PromiseOrValue<IUserPosts>) => {
      const old = get($UserPostStore);
      set($UserPostStore, { ...old, [userLinkName]: input });
    },
  );

  a.debugLabel = `$UserPost+${encodeURIComponent(userLinkName)}`;

  return a;
});

export const $UserPostLoadmore = safeAtomFamily((userLinkName: string) => {
  const a = atom<null, [IUserPosts], void>(null, async (get, set, input) => {
    const store = get($UserPostStore);
    const old = await store[userLinkName];

    if (old) {
      set($UserPostStore, {
        ...store,
        [userLinkName]: {
          ...input,
          items: [...old.items, ...input.items],
        },
      });
    }
  });

  a.debugLabel = `$UserPostLoadmore+${encodeURIComponent(userLinkName)}`;
  return a;
});
